<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Senarai Cukai Tertunggak">

            <z-table 
            ref="tbluser"
            :title="'Cukai Tertunggak&nbsp;'+link_abt.title" 
            :headers="table.headers" 
            :items="table.items" 
            :meta="table.meta" class="">
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    link_abt: [Array, Object],
    type: String,
  },
  data() {
    return {
        resourceurl: this.service_tunggakan+'abt1/cukai_tertunggak',
        reload: true,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Tunggakan Hasil', route: '/tunggakanhasil' },
            { label: 'Akaun Belum Terima', route: '/tunggakanhasil/akaunbelumterima' },
            { label: this.link_abt.label, route: this.link_abt.route },
            { label: 'Cukai Tertunggak', route: '/akaun_belum_terima/abt_1/cukai_tertunggak' },
          ],
          cari : {bulan: '', tahun: ''},
          }
  },
  methods: {

  search() {
      this.$inertia.visit(window.route('akaun_belum_terima.abt_1.cukai_tertunggak')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },

    reset(){
      this.cari = {bulan: '', tahun: ''}
      this.search()
    },
       
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.bulan == 'undefined'){this.cari.bulan = ''}
    if(this.cari.tahun == 'undefined'){this.cari.tahun = ''}
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>